import React, { Fragment } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import Link from '../Link/index.js';
import '../../index-2586sEvh.js';
import '../../_commonjsHelpers-jjO7Zipk.js';
import 'next/link';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Breadcrumbs = ({ items, currentItem }) => {
    const { t: tLabel } = useTranslation('', { keyPrefix: '$common.$labels' });
    const { locale } = useRouter();
    return (React.createElement("nav", { "aria-label": "Breadcrumb" },
        React.createElement("ol", { className: "breadcrumb" },
            React.createElement("li", null,
                React.createElement(Link, { href: `/${locale}`, black: true, noUnderline: true }, tLabel('homepage'))),
            items.map((item, index) => item.name !== currentItem ? (
            // eslint-disable-next-line react/no-array-index-key
            React.createElement(Fragment, { key: index },
                React.createElement("li", null,
                    React.createElement(Link, { href: item.url, black: true, noUnderline: true }, item.name)))) : null),
            React.createElement("li", { className: "active" },
                React.createElement("span", { "aria-current": "page" }, currentItem)))));
};

export { Breadcrumbs as default };
//# sourceMappingURL=index.js.map
